/**
 * Centralized configuration for the application
 * Reads from environment variables (REACT_APP_*)
 */

const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
};

/**
 * Helper function to construct full API URL
 * @param {string} endpoint - API endpoint (e.g., '/api/form/create')
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${config.API_BASE_URL}${cleanEndpoint}`;
};

// Export config values
export const API_BASE_URL = config.API_BASE_URL;

export default config;
